import { isEncompass } from '$Utilities/integrationPlatform';

const VideoEventHeaderSubText = (): string => {
    const pageSubTitle = 'Each video event categorization represents a potential driving incident for your review.';
    const pageSubTitleEnc =
        ' Drivers will be automatically assigned to video events if an ELD event with an assigned driver was processed for the vehicle within one hour prior to when the video event occurred. We suggest you check all events for accuracy.';
    return pageSubTitle.concat(isEncompass ? pageSubTitleEnc : '');
};

export default VideoEventHeaderSubText;
